/**
 * 모달/다이얼로그 닫기 버튼(.close_button) 위치·색상 — 파일별 실측 좌표를 인자로 그대로 전달해 렌더 결과 보존
 * 좌표 계열: 8/8(important) · 8/8(no-important) · 24/16(+ MuiSvgIcon-root) · 27/27 · 8/5(margin-right:auto) · 27/21
 */
export const dialogCloseButtonStyles = (
  theme: any,
  {
    right = '8px',
    top = '8px',
    important = true,
    withPadding = false,
    marginRightAuto = false,
    iconSize,
  }: {
    right?: string;
    top?: string;
    important?: boolean;
    withPadding?: boolean;
    marginRightAuto?: boolean;
    iconSize?: string;
  } = {},
) => `
  .close_button {
    position: absolute${important ? ' !important' : ''};
    ${withPadding ? `padding: 0px${important ? ' !important' : ''};` : ''}
    ${marginRightAuto ? 'margin-right: auto;' : ''}
    right: ${right}${important ? ' !important' : ''};
    top: ${top}${important ? ' !important' : ''};
    color: ${theme.palette.grey[500]};
    ${
      iconSize
        ? `
    .MuiSvgIcon-root{
      width: ${iconSize};
      height: ${iconSize};
    }`
        : ''
    }
  }
`;

/**
 * AG Grid 등 목록을 담은 다이얼로그 셸(고정 하단 액션바) — EventSlack/SlackConfigCopyModal ↔
 * DeviceProfile/ProfileAssign/DeviceAssignModal 2곳 파일 전체(export 이름만 다름) 바이트 동일 →
 * 이 정본 프래그먼트를 그대로 alias.
 */
export const gridDialogShellStyles = (theme: any) => `
  .MuiDialogTitle-root {
    padding: 27px;
    flex-shrink: 0;
  }

  /* paper overflow:visible 제거 — 행이 많을 때 액션 버튼이 뷰포트 밖으로 밀리는 회귀 방지 */
  & .MuiDialog-container > .MuiPaper-root {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    overflow: hidden;
  }

  ${dialogCloseButtonStyles(theme)}
`;

/**
 * TextField shrink 라벨이 잘리지 않도록 overflow:visible을 유지하는 폼 다이얼로그 셸 —
 * DeviceProfile::ProfileCopyDialog / EventSlack/SlackConfigFormModal::SlackConfigDialog /
 * EventSetting/MgmtStateEventFormModal::MgmtStateEventDialog / EventSetting/
 * NoiseFilterFormModal::NoiseFilterDialog / DeviceTypeList::DeviceTypeDialog 5곳
 * 바이트 동일(export 이름만 다름) → 이 정본 프래그먼트를 그대로 alias.
 */
export const formDialogShellStyles = (theme: any) => `
  .MuiDialogTitle-root {
    padding: 27px;
  }

  .MuiDialogContent-root {
    overflow: visible;
    padding-top: 12px;
  }

  .MuiPaper-root {
    overflow: visible;
  }

  ${dialogCloseButtonStyles(theme)}
`;

/**
 * 다이얼로그 타이틀 여백만 제거하는 컴팩트 셸 — ConfirmModal::ConfirmModalDialog ↔
 * AgGrid::EditModalDialog 2곳 바이트 동일(export 이름만 다름) → 이 정본 프래그먼트를 그대로 alias.
 */
export const compactDialogShellStyles = (theme: any) => `
    .dialog_title_text{
        margin-bottom: 0px;
    }

    ${dialogCloseButtonStyles(theme, { right: '24px', top: '16px', withPadding: true, iconSize: '20px' })}
    .loading {
        color: #ffffff;
    }
    `;

/**
 * 컴팩트 셸 + info_card(27px 패딩) + lot_button 조합 — mes/Defect::DefectInputModalDialog ↔
 * mes/Stock::StockAdjustmentModalDialog 2곳 바이트 동일(export 이름만 다름) →
 * 이 정본 프래그먼트를 그대로 alias.
 */
export const compactInfoCardDialogShellStyles = (theme: any) => `
  .dialog_title_text{
      margin-bottom: 0px;
  }
  .info_card {
    padding: 27px !important;
  }
  .lot_button {
    opacity: 1 !important;
  }
  ${dialogCloseButtonStyles(theme, { right: '24px', top: '16px', important: true, withPadding: true, iconSize: '20px' })}
  .loading {
      color: #ffffff;
  }
  `;
